var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.166 7.834a.47.47 0 00-.46.46c0 1.01-.675 1.839-1.534 1.839H2.827c-.858-.008-1.533-.829-1.533-1.84a.47.47 0 00-.46-.459.47.47 0 00-.459.46c0 1.531 1.104 2.758 2.453 2.758h6.344c1.349 0 2.453-1.227 2.453-2.759a.47.47 0 00-.46-.459z",
    fill: "#29C1B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.678 8.048a.529.529 0 00.675 0L8.1 6.3a.456.456 0 00-.643-.643l-.95.95V1.396a.461.461 0 00-.921 0v5.213l-.951-.95a.456.456 0 00-.643.642l1.686 1.748z",
    fill: "#29C1B9"
  })));
}
export default SvgDownload;